<aside class="side-menu mobile" ClickOutside (clickOutside)="sidebar.close()"
       [options]="{ignoreOutsideComponents: ['.burger-menu']}"
       [ngClass]="{open: sidebar.isOpen}">
  <div class="side-menu-container">
    <div class="side-menu__header">
      <a *appShellNoSSR [href]="seo.originalLocationUrl + '/' + lang.current" [routerLink]="['/', lang.current]">
        <img class="side-menu__header-logo" [src]="'/assets/img/logo' + '.svg'" alt="logo">
      </a>
      <div class="side-menu__switchers">
        <app-locales-selector></app-locales-selector>
        <app-theme-selector></app-theme-selector>
      </div>
    </div>
    <div class="side-menu__main">
      <div class="side-menu__info">
        @if (user.auth) {
          <div class="side-menu__info-balance card">
            <app-header-balance></app-header-balance>
          </div>
        } @else {
          <div class="side-menu__info-balance not-auth">
            <button
              [routerLink]="['/', lang.current, 'register']"
              class="btn small glowing-btn">
              {{ 'btn.signup-get-bonus' | translate }}
            </button>
          </div>
        }
        <ng-template #notAuth>
          <div class="side-menu__info-balance not-auth">
            <button
              [routerLink]="['/', lang.current, 'register']"
              class="btn small glowing-btn">
              {{ 'btn.signup-get-bonus' | translate }}
            </button>
          </div>
        </ng-template>
        @if (zendesk.available) {
          <div (click)="zendesk.toggle()" class="side-menu__info-support card">
            <i class="icon-support"></i>
            <span>{{ 'link.help' | translate }}</span>
          </div>
        }
        <div class="side-menu__info-app card" [ngClass]="{'disabled': installApp.isNativeApp}" (click)="installPwa()">
          <i class="icon-app"></i>
          @if (window.isIphoneDevices) {
            <div (click)="openInformer()" class="informer">
              <i class="icon-informer"></i>
            </div>
          }
          <span>{{ 'link.install-app' | translate }}</span>
        </div>
      </div>
      <div class="side-menu__main-nav">
        <nav class="nav">
          @if (summer.store().page) {
            <div
              class="nav__item nav__item--promo"
              routerLinkActive="active"
              [routerLink]="['/', lang.current, 'promo', 'summer']">
              <img src="/assets/img/promo/summer/side.png" alt="">
              <span class="promo-link text-gradient">
                {{ 't.spins-safari' | translate }}
              </span>
            </div>
          }
          @if (user.auth) {
            <div class="nav__item"
                 routerLinkActive="active"
                 [routerLink]="['/', lang.current, 'account']"
                 [routerLinkActiveOptions]="{exact: true}">
              <i class="icon icon-user"></i>
              <span>{{ 'link.account' | translate }}</span>
            </div>
          }
          <div
            class="nav__item"
            routerLinkActive="active"
            [routerLink]="['/', lang.current, 'crypto-spin']"
          >
            <i class="icon icon-crypto-spin"></i>
            <span>{{ 'link.crypto-spin' | translate }}</span>
          </div>
          <div
            class="nav__item"
            routerLinkActive="active"
            [routerLink]="['/', lang.current, 'bonuses']"

          >
            <i class="icon icon-gift"></i>
            <span>{{ 'link.bonuses' | translate }}</span>
          </div>
          @if (user.auth) {
            <div
              class="nav__item"
              routerLinkActive="active"
              [routerLink]="['/', lang.current, 'account']"
              [queryParams]="{tab: 'missions'}"
            >
              <i class="icon icon-missions"></i>
              <span>{{ 'link.missions' | translate }}</span>
            </div>
          }
          @if (bonusStore.bonusStorePage$ | async) {
            <div
              class="nav__item"
              routerLinkActive="active"
              [routerLink]="['/', lang.current, 'bonus-shop']"
            >
              <i class="icon icon-shop"></i>
              <span>{{ 'link.bonus-shop' | translate }}</span>
            </div>
          }
          <div
            class="nav__item"
            routerLinkActive="active"
            [routerLink]="['/', lang.current, 'loyalty']"

          >
            <i class="icon icon-side-jackpot"></i>
            <span>{{ 'link.loyalty' | translate }}</span>
          </div>
          <div
            class="nav__item"
            routerLinkActive="active"
            [routerLink]="['/', lang.current, 'tournaments']"
          >
            <i class="icon icon-tournaments"></i>
            <span>{{ 'link.tournaments' | translate }}</span>
          </div>
          <div routerLinkActive="active"
               #accordionGames=accordionDirective
               Accordion
               #submenuGames
               (click)="clickSubmenuGames()"
               class="nav__item">
            <i class="icon icon-play"></i>
            <span>{{ 'btn.play' | translate }}</span>
            <i class="icon-arrow"></i>
          </div>
          <div class="nav__item-submenu">
            @for (menu of gamesMenu; track $index) {
              <a
                [routerLink]="['/', lang.current, 'games', menu?.link]"
                routerLinkActive="active"
                class="nav__item-submenu--item">
                {{ menu?.title | translate }}
              </a>
            }
          </div>
          <div (click)="clickSubmenuMore()"
               #accordionMore=accordionDirective
               #submenuMore
               Accordion
               class="nav__item more"
          >
            <i class="icon icon-more"></i>
            <span>{{ 'btn.more' | translate }}</span>
            <i class="icon-arrow"></i>
          </div>
          <div class="nav__item-submenu">
            @if (user.auth) {
              @for (menu of moreMenu?.auth; track $index) {
                <a
                  routerLinkActive="active"
                  [routerLink]="['/', lang.current, 'account', menu.link]"
                  class="nav__item-submenu--item"
                >
                  {{ menu?.title | translate }}
                </a>
              }
              @for (menu of moreMenu?.notAuth; track $index) {
                <a
                  routerLinkActive="active"
                  [routerLink]="['/', lang.current, menu.link]"
                  [hidden]="menu?.hidden"
                  class="nav__item-submenu--item"
                >
                  {{ menu?.title | translate }}
                </a>
              }
            }
            @if (!user.auth) {
              @for (menu of moreMenu?.notAuth; track $index) {
                <a
                  [routerLink]="['/', lang.current, menu.link]"
                  [hidden]="menu?.hidden"
                  routerLinkActive="active"
                  class="nav__item-submenu--item"
                >
                  {{ menu?.title | translate }}
                </a>
              }
            }
            @if (user.auth) {
              <div class="nav__item-submenu--item logout">
                <button (click)="onLogoutClick()" class="btn-attention">
                  {{ 'link.logout' | translate }}
                </button>
              </div>
            }
          </div>
        </nav>
      </div>
    </div>
  </div>
</aside>
